var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _c(
        "v-app-bar",
        {
          staticClass: "d-flex justify-center",
          attrs: {
            app: "",
            absolute: "",
            "clipped-right": "",
            flat: "",
            height: "72",
          },
        },
        [
          _c(
            "v-responsive",
            { attrs: { "max-width": "300" } },
            [
              _c("ChangeResolution", {
                on: {
                  changeResolution: (value) => _vm.changeResolution(value),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        { attrs: { permanent: "", app: "", width: "500" } },
        [
          _c(
            "v-app-bar",
            {
              attrs: {
                absolute: "",
                "clipped-left": "",
                flat: "",
                height: "72",
              },
            },
            [_c("ActionsBar", { on: { onSave: _vm.onSave } })],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex flex-row full-height" },
            [
              _c(
                "v-navigation-drawer",
                {
                  attrs: {
                    permanent: "",
                    color: "grey darken-3",
                    width: "100",
                  },
                },
                [
                  _c("ListNavigations", {
                    attrs: {
                      onSave: _vm.onSave,
                      selected: _vm.selected,
                      checkChangedData: _vm.checkChangedData,
                    },
                    on: {
                      onSelectNavigation: (key) => _vm.onSelectNavigation(key),
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-navigation-drawer",
                { attrs: { permanent: "", width: "400" } },
                [
                  _c("EditDetailPart", {
                    ref: "edit-part",
                    attrs: {
                      selected: _vm.selected,
                      reloadIframe: _vm.reloadIframe,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-main",
        [
          _c("IFrameLearningPage", {
            ref: "iframe",
            attrs: {
              domain: `${_vm.learningDomain}` + `${_vm.path}`,
              resolution: _vm.resolution,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.aiBuilderOpen,
              expression: "!aiBuilderOpen",
            },
          ],
          staticClass: "ai-assistance-widget",
        },
        [
          _c(
            "div",
            {
              staticClass: "ai-assistant-bubble",
              on: {
                click: function ($event) {
                  _vm.aiBuilderOpen = true
                },
              },
            },
            [
              _c("div", { staticClass: "bubble-header" }, [
                _c("div", { staticClass: "d-flex align-center" }, [
                  _c(
                    "div",
                    { staticClass: "assistant-icon-badge" },
                    [
                      _c("v-icon", { attrs: { size: "16", color: "white" } }, [
                        _vm._v("mdi-creation"),
                      ]),
                    ],
                    1
                  ),
                  _c("span", { staticClass: "assistant-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$vuetify.lang.t(
                            "$vuetify.SITE_BUILDER.AI_BUILDER.ASSISTANT_TITLE"
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "assistant-status-dot" }),
              ]),
              _c("div", { staticClass: "bubble-body" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t(
                        "$vuetify.SITE_BUILDER.AI_BUILDER.ASSISTANT_SUBTITLE"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "bubble-arrow" }),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "ai-assistance-fab ai-assistance-btn",
              attrs: {
                type: "button",
                "aria-label": _vm.$vuetify.lang.t(
                  "$vuetify.SITE_BUILDER.AI_BUILDER.BUTTON"
                ),
              },
              on: {
                click: function ($event) {
                  _vm.aiBuilderOpen = true
                },
              },
            },
            [
              _c("v-icon", { attrs: { size: "26", color: "white" } }, [
                _vm._v("mdi-creation"),
              ]),
            ],
            1
          ),
        ]
      ),
      _c("AIBuilderPopup", {
        ref: "aiPopup",
        attrs: { "page-key": _vm.selected },
        on: { apply: _vm.onAiBuilderApply },
        model: {
          value: _vm.aiBuilderOpen,
          callback: function ($$v) {
            _vm.aiBuilderOpen = $$v
          },
          expression: "aiBuilderOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }